/**
 * 纯 JS HMAC-SHA256（不依赖 crypto.subtle，兼容 HTTP 非安全上下文）
 * 与后端 Hutool HMac(HmacSHA256).digestHex 一致：UTF-8 字节 → 小写十六进制
 */

function utf8Encode (str) {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(String(str))
  }
  const s = unescape(encodeURIComponent(String(str)))
  const out = new Uint8Array(s.length)
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i)
  return out
}

function rotr (n, x) {
  return (x >>> n) | (x << (32 - n))
}

function sha256 (bytes) {
  const K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ]
  let h0 = 0x6a09e667
  let h1 = 0xbb67ae85
  let h2 = 0x3c6ef372
  let h3 = 0xa54ff53a
  let h4 = 0x510e527f
  let h5 = 0x9b05688c
  let h6 = 0x1f83d9ab
  let h7 = 0x5be0cd19

  const l = bytes.length
  const bitLenHi = Math.floor(l / 0x20000000)
  const bitLenLo = (l << 3) >>> 0
  const withPad = new Uint8Array(((l + 9 + 63) & ~63))
  withPad.set(bytes)
  withPad[l] = 0x80
  const view = new DataView(withPad.buffer)
  view.setUint32(withPad.length - 8, bitLenHi, false)
  view.setUint32(withPad.length - 4, bitLenLo, false)

  const w = new Uint32Array(64)
  for (let i = 0; i < withPad.length; i += 64) {
    for (let j = 0; j < 16; j++) {
      w[j] = view.getUint32(i + j * 4, false)
    }
    for (let j = 16; j < 64; j++) {
      const s0 = rotr(7, w[j - 15]) ^ rotr(18, w[j - 15]) ^ (w[j - 15] >>> 3)
      const s1 = rotr(17, w[j - 2]) ^ rotr(19, w[j - 2]) ^ (w[j - 2] >>> 10)
      w[j] = (w[j - 16] + s0 + w[j - 7] + s1) >>> 0
    }
    let a = h0
    let b = h1
    let c = h2
    let d = h3
    let e = h4
    let f = h5
    let g = h6
    let h = h7
    for (let j = 0; j < 64; j++) {
      const S1 = rotr(6, e) ^ rotr(11, e) ^ rotr(25, e)
      const ch = (e & f) ^ (~e & g)
      const t1 = (h + S1 + ch + K[j] + w[j]) >>> 0
      const S0 = rotr(2, a) ^ rotr(13, a) ^ rotr(22, a)
      const maj = (a & b) ^ (a & c) ^ (b & c)
      const t2 = (S0 + maj) >>> 0
      h = g
      g = f
      f = e
      e = (d + t1) >>> 0
      d = c
      c = b
      b = a
      a = (t1 + t2) >>> 0
    }
    h0 = (h0 + a) >>> 0
    h1 = (h1 + b) >>> 0
    h2 = (h2 + c) >>> 0
    h3 = (h3 + d) >>> 0
    h4 = (h4 + e) >>> 0
    h5 = (h5 + f) >>> 0
    h6 = (h6 + g) >>> 0
    h7 = (h7 + h) >>> 0
  }

  const out = new Uint8Array(32)
  const outView = new DataView(out.buffer)
  outView.setUint32(0, h0, false)
  outView.setUint32(4, h1, false)
  outView.setUint32(8, h2, false)
  outView.setUint32(12, h3, false)
  outView.setUint32(16, h4, false)
  outView.setUint32(20, h5, false)
  outView.setUint32(24, h6, false)
  outView.setUint32(28, h7, false)
  return out
}

function toHex (bytes) {
  let s = ''
  for (let i = 0; i < bytes.length; i++) {
    s += (bytes[i] >>> 4).toString(16)
    s += (bytes[i] & 0xf).toString(16)
  }
  return s
}

/**
 * @param {string} key
 * @param {string} data
 * @returns {string} 小写十六进制 HMAC-SHA256
 */
export function hmacSha256Hex (key, data) {
  const blockSize = 64
  let keyBytes = utf8Encode(key)
  if (keyBytes.length > blockSize) {
    keyBytes = sha256(keyBytes)
  }
  const k = new Uint8Array(blockSize)
  k.set(keyBytes)
  const oKey = new Uint8Array(blockSize)
  const iKey = new Uint8Array(blockSize)
  for (let i = 0; i < blockSize; i++) {
    oKey[i] = k[i] ^ 0x5c
    iKey[i] = k[i] ^ 0x36
  }
  const dataBytes = utf8Encode(data)
  const inner = new Uint8Array(blockSize + dataBytes.length)
  inner.set(iKey)
  inner.set(dataBytes, blockSize)
  const innerHash = sha256(inner)
  const outer = new Uint8Array(blockSize + 32)
  outer.set(oKey)
  outer.set(innerHash, blockSize)
  return toHex(sha256(outer))
}



// WEBPACK FOOTER //
// ./src/libs/hmacSha256.js